export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '57a0925e-bd2e-442a-8d82-49fd50e91c11';
export const MODAL_CLOSE_SEC = 2.5;
